import { FC } from "react";
import { ICellRendererParams } from "ag-grid-community";
import { budgetAmountCellValueGetter } from "@/components/pages/budgets-and-alerts/components/grids/budgets/utils/helpers/value-getters/budgetAmountCellValueGetter";
import { Budget } from "@/services/cloudchipr.api";
import { money } from "@/utils/numeral/money";
import { useAppSelector } from "@/store/hooks";
import { organisationQuarterStartMonthSelector } from "@/store/common/selectors/org-current-settings/organisationQuarterStartMonthSelector";
import { TypographyWithCopy } from "@/components/common/TypographyWithCopy";

export const BudgetAmountCell: FC<ICellRendererParams<Budget>> = ({
  data: budget,
}) => {
  const quarterStartMonth = useAppSelector(
    organisationQuarterStartMonthSelector,
  );

  if (!budget) {
    return;
  }

  const budgetAmount = budgetAmountCellValueGetter(budget, quarterStartMonth);
  const value = money(budgetAmount);

  return (
    <TypographyWithCopy value={value} variant="body2" fontWeight="medium" />
  );
};
